import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const ClientSecretModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1em 2.5em;
`;

export const WarningContainer = styled.div`
  display: flex;
  border: 1px solid ${colours.elexonOrange};
  border-radius: 3px;
  padding: 1em;
  margin: 1em 0;
  width: 100%;

  p {
    padding-left: 5px;
  }
`;

export const ClientSecretDetailsContainer = styled.div`
  width: 100%;
`;

export const ClientSecretDetailsRow = styled.div`
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) max-content;
  column-gap: 0.1em;
  align-items: center;
  padding: 0.2em 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 0.5em;
  }
`;

export const ClientSecretDetailsLabel = styled.span`
  font-weight: ${fontWeights.bold};
  color: ${colours.elexonBlack};
`;

export const ClientSecretDetailsValue = styled.span`
  color: ${colours.darkGrey};
  word-break: break-word;
`;

export const ButtonsContainer = styled.div`
  margin-top: 2.75em;
`;

export const LoadingSpinnerContainer = styled.div`
  height: 8em;
  text-align: center;
  margin-top: 4em;
  margin-bottom: 6em;
`;
